import isAdmin from "@/components/helpers/isAdmin"
import { receiveUpdateUserConstituent } from "@/components/profile/ducks/Actions"
import { receiveTasks } from "@/components/tasks/admin/ducks/Actions"
import store from "store/store"

const receiveUpdateSuccessWithTasks = (cb) => (response) => {
  const { dispatch } = store
  const { currentConstituent } = response
  const currentUserIsAdmin = isAdmin(
    store.getState().profile.user.currentUser,
    store.getState().customer.user.customer,
    store.getState().permissions.admin.showAdminView,
  )

  if (currentUserIsAdmin) {
    dispatch(receiveTasks(response.tasks))
  }
  dispatch(receiveUpdateUserConstituent(currentConstituent))
  if (cb) {
    cb()
  }
}

export default receiveUpdateSuccessWithTasks
